import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

// import {DocumentHead} from "components/documentHead";

import { MainWrapper } from 'legacyComponents/styled/lib';
import { ThreadBody } from 'apps/forum/thread/body';

@withNamespaces()
@inject('routerStore')
@observer
export class Thread extends React.Component {
  render() {
    const { params, initiativeManager } = this.props;
    return (
      <>
        <MainWrapper>
          <ThreadBody
            hideAction
            params={params}
            initiativeManager={initiativeManager}
          />
        </MainWrapper>
      </>
    );
  }
}

Thread.propTypes = {
  routerStore: PropTypes.object,
  routeName: PropTypes.string,
  params: PropTypes.object,
  initiativeManager: PropTypes.object,
  t: PropTypes.func,
};
